// extracted by mini-css-extract-plugin
export default {"root":"Slider_root__TXsP9"};